/** Remove edge-injected #lcp-paint after React mounts (image is browser-cached). */
export function clearLcpPaint(): void {
  if (typeof document === "undefined") return;
  document.getElementById("lcp-paint")?.remove();
  document.getElementById("lcp-paint-style")?.remove();
}

export function hasLcpPaint(): boolean {
  if (typeof document === "undefined") return false;
  return Boolean(document.getElementById("lcp-paint"));
}
